import store from '@/store';
import router from '@/router';
import { ActionType, Routes } from '@/constants';
import { HomeSummary } from '@/types';

const setRememberMe = (jobId: string) => {
  store.dispatch(ActionType.UPDATE_SELECTED_JOB, jobId);
  localStorage.setItem('selectedJob', jobId);
};

const getRememberMe = () => {
  return localStorage.getItem('selectedJob');
};

const defaultHomeImage = () => require('@/assets/images/defaultHome.png');

const userHomeSelection = () => {
  let selectedHome: string | undefined | null;
  const { hasUserData, jobs } = store.getters;
  if (hasUserData && jobs.length > 1) {
    selectedHome = getRememberMe();
    if (!selectedHome) {
      router.push({ name: Routes.SELECT_HOME });
    } else {
      setRememberMe(selectedHome);
    }
  } else if (hasUserData) {
    setRememberMe(jobs[0].jobId);
  }
  return jobs[0].jobId;
}

const filterJobsbyId = (jobId: string) => store.getters.user.jobs.find((job: HomeSummary) => job.jobNumber === jobId);

export {
  setRememberMe,
  getRememberMe,
  userHomeSelection,
  filterJobsbyId,
  defaultHomeImage
};
